<template>
	<div class="content">
		<div class="editInfor">
			<div>
				<div>
					<span class="red">*</span>手机号:
				</div>
				<div>
					<input type="text" v-model="CustomerPhone" @keypress="searchCustomers($event)" placeholder="扫描会员二维码"
						required="required" />
					<span class="err">{{$uil.checkPhone(CustomerPhone)?' ':'×'}}</span>
				</div>
				<div>
					<span class="red"></span>会员姓名:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="CustomerName" required="required"
						placeholder="会员姓名" />

					<span class="err">{{$uil.checkchinese(CustomerName,2,6)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red"></span>孩子数量:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="CustomerChild" required="required"
						placeholder="会员孩子数量" />
				</div>

				<div>
					<span class="red"></span>孩子年龄:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="age" required="required" placeholder="孩子年龄" />

					<span class="err">{{age>=0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red"></span>孩子学校:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="school" required="required" placeholder="孩子学校" />

					<span class="err"> </span>
				</div>


				<div>
					<span class="red"></span>会员分类:
				</div>
				<div>
					<select v-model="VipLevlID">
						<option v-for="(i,index) in vipLevl" :value="i.vipLevlID">{{i.Price +' '+i.vipTag}}</option>
					</select>
				</div>
				<div>
					<span class="red"></span>开始时间:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="VipBeginDate" placeholder="格式:2021-01-01" />

				</div>

				<div>
					<span class="red"></span>结束时间:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="VipEndDate" placeholder="格式:2021-01-01" />

				</div>
				<div>
					<span class="red"></span>退回会员费:
				</div>
				<div>
					<input type="text" v-model="Disbursements" />
					{{Disbursements1 | rmb}}

				</div>

				<div>
					<span class="red"></span>退回书箱费:
				</div>
				<div>
					<input type="text" v-model="boxMoney" />
					{{boxMoney1 | rmb}}
				</div>


				<div>
					<span class="red"></span>退还押金:
				</div>
				<div>
					<input type="text" v-model="Deposit" />
					{{Deposit1 | rmb}}
				</div>
				
				<div>
					<span class="red"></span>退还押金:
				</div>
				<div>
					<input type="text" v-model="BelongTo" />
					 
				</div>
				
				<div>
					<span class="red"></span>会员状态:
				</div>
				<div>
				  <select  v-model="CustomerState">
				  	<option v-for='(i,index) in state' :value="i.id">{{i.text}}</option>
				  </select>
				</div>
				
				<div>
					<span class="red">{{Disbursements==0?"*":''}}</span>备注:
				</div>
				<div>
					<textarea v-model="remarks"></textarea>
					<span class="err"> </span>
				</div>

				<div>
					<span class="red"></span>合计:
				</div>
				<div>
					<span>退费:{{(Disbursements*1+Deposit*1+boxMoney*1) | rmb}}</span>
				</div>
				<div>
				</div>
				<div>
					<button class="button" :class="{'disabled':!checkDate}" :disabled="!checkDate"
						@click="editCustomer">{{ CustomerID==0?'确定':'确定'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="clear()">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import j from './j.js'
	export default j
</script>

<style>
</style>
